// 支付方法：alipay  wxpay
function applay(method, data) {
	uni.requestPayment({
		provider: method,
		orderInfo: data, //微信、支付宝订单数据
		...data, //小程序参数放在最外级
		success: function(res) {
			console.log('success:' + JSON.stringify(res));
			uni.showLoading({
				title: '支付成功'
			})
			setTimeout(() => {
				uni.navigateBack()
			}, 1000)
		},
		fail: function(err) {
			uni.showLoading({
				title: '支付失败'
			})
			setTimeout(() => {
				uni.hideLoading()
			}, 1000)
			console.log('fail:' + JSON.stringify(err));
		}
	});
}

// 提示
function tishi(e) {
	uni.showToast({
		icon: 'none',
		title: e,
		duration: 2000
	});
}

//router路由跳转
function router(type, s, donghua, i) { //查看动画：https://uniapp.dcloud.io/api/router?id=animation
	if (type == 1) { //保留当前页面，跳转到应用内的某个页面(使用uni.navigateBack可以返回到原页面)
		uni.navigateTo({
			url: s,
			animationType: donghua,
			animationDuration: i || 200
		});
	} else if (type == 2) { //关闭当前页面，跳转到应用内的某个页面。
		uni.redirectTo({
			url: s,
			animationType: donghua,
			animationDuration: i || 200
		});
	} else if (type == 3) { //关闭所有页面，打开到应用内的某个页面。
		uni.reLaunch({
			url: s,
			animationType: donghua,
			animationDuration: i || 200
		});
	} else if (type == 4) { //关闭当前页面，返回上一页面或多级页面。可通过 getCurrentPages() 获取当前的页面栈，决定需要返回几层。
		uni.navigateBack({
			delta: s,
			animationType: donghua,
			animationDuration: i || 200
		});
	} else if (type == 5) { //预加载页面，是一种性能优化技术。被预载的页面，在打开时速度更快。
		uni.preloadPage({
			url: s,
		});
	}
}

function previewImage(e, i) {

	if (Array.isArray(e)) {
		var current = i
		var urls = e
	} else {
		var current = 0
		var urls = [e]
	}

	uni.previewImage({
		current: current,
		urls: urls
	});
}

function statusHeights() {
	var height

	height = 44;





	uni.getSystemInfo({
		success: (e) => {
			height = height + e.statusBarHeight;
		}
	})
	return height
}

function closePage() {
	let u = navigator.userAgent
	let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //安卓端
	let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
	if (isAndroid) {
		// window.androidjs.checkLoginState("1");
		android.onkeyBack()
	}
	if (isIOS) {
		window.webkit.messageHandlers.onkeyBack.postMessage('1')
	}
}

export default {
	applay, //this.$_applay(支付方式,支付参数)
	tishi, //this.$_tishi(提示内容)
	router, //this.$_router(跳转方式,跳转路径,跳转动画，动画时长)
	previewImage, //$_previewImage(list,index) $_previewImage(url)
	statusHeights, //:style="{marginTop:$_statusHeights()+'px'}"
	closePage
}